<template>
  <section>
    <!-- モーダル画面 -->
    <div style="display: flex;">
      <!-- アラートダイアログ -->
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
    <div style="border-radius: 5px;">
      <!-- タイトル -->
      <header>
        <p style="font-size: 20px;">
          GoogleDrive
        </p>
      </header>
      <div>
        <!-- GoogleDrive読み込み中 -->
        <template v-if="isDriveLoading">
          <div style="height: auto; width: 100%; display: flex; justify-content: center; align-items: center;">
            <span class="mdi mdi-loading mdi-spin"></span>GoogleDriveを読み込んでいます。
          </div>
        </template>
        <template v-else>
          <!-- フォルダ新規作成 -->
          <b-field>
            <div style="padding-right:100px;">
              <!-- 上位フォルダに戻る -->
              <p>
                <span class="mdi mdi-folder-upload mdi-18px" style="width: 21px; cursor: pointer;" @click="upFolder" :class="{ 'is-confirm': isConfirm }">
                  上のフォルダに戻る
                </span>
              </p>
            </div>
            <!-- 新規フォルダ作成 -->
            <input
              style="width: 50%; is-small"
              placeholder="新規フォルダ作成"
              v-model="newFolderName"
              :disabled="isConfirm"
            />
            <!-- 新規作成ボタン -->
            <button
              style="padding: 4px; cursor: pointer;"
              :disabled="newFolderName.length <= 0 || isConfirm"
              @click="createFolder(newFolderName)"
            >
              <span
                class="mdi mdi-folder-edit mdi-18px"
              />
            </button>
          </b-field>
          <!-- GoogleDriveフォルダ一覧 -->
          <section class="table-section">
            <table class="item-list-table" :class="{ 'is-confirm': isConfirm }">
              <tr class="table-header">
                <td style="width: 21px;"></td>
                <td style="width: 60%;">フォルダ名/ファイル名</td>
                <td style="width: 10%;"></td>
                <td>作成日</td>
              </tr>
              <tr v-for="(item, idx) in itemList"
               :key="idx"
               :class="{ active: isActive(idx), 'item-folder': isFolder(item), 'item-file': !isFolder(item) }"
               @click="updateActiveNumber(idx, item)"
               @dblclick="activeNumber = null"
               >
                <td><span class="mdi mdi-delete mdi-18px" @click="deleteFolderConfirm(item)" v-show="isFolder(item)"></span></td>
                <td @click="setFolder(item)" @dblclick="downFolder(item)">{{item.name}}</td>
                <td @click="setFolder(item)" @dblclick="downFolder(item)">{{item.shared ? '[共有]' : ''}}</td>
                <td @click="setFolder(item)" @dblclick="downFolder(item)">{{getCreatedTime(item.createdTime)}}</td>
              </tr>
            </table>
          </section>
            <p>※削除できるフォルダは、本画面から作成した空フォルダのみです。</p>
        </template>
      </div>
      <p style="text-align: left; padding-top:16px;  font-weight: 600;">選択中フォルダ</p>
      <p style="padding: 16px;">{{getDirName}}</p>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import ModalAlertDialog from '@/components/organisms/common/ModalAlertDialog'
import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
  /** アラート表示データ作成 */
  createAlertData
} from '@/functions/common/alertFunc'

export default {
  components: {
    /** アラートダイアログ */
    ModalAlertDialog,
  },
  data () {
    return {
      /** フォルダのMIMRタイプ */
      GOOGLE_DRIVE_FOLDER  : 'application/vnd.google-apps.folder',
      /** アラートダイアログオープンフラグ */
      isAlertDialogOpen: false,
      /** アラートダイアログデータ */
      alertData        : {},
      /** GoogleDrive読み込みフラグ */
      isDriveLoading   : false,
      /** カレントフォルダ内リスト */
      itemList         : [],
      /** 新規作成フォルダ名 */
      newFolderName    : '',
      /** 削除対象フォルダ */
      delTargetFolder  : {},
      /** フォルダパス履歴 */
      pathHistory      : {},
      /** 選択フォルダ情報 */
      selectedFolder   : {
        id      : '',
        name    : '',
        mimeType: '',
        parents : []
      },
      /** 一時非表示 */
      temporaryHideFolderID: [],
      /** クリックされた行のインデックス */
      activeNumber: null
    }
  },
  props: {
    /** GoogleDrive連携ユーザーID */
    userId    : {
      type    : String,
      required: true,
      default : ''
    },
    /** 保存済みフォルダID */
    folderId  : {
      type    : String,
      required: false,
      default : ''
    },
    /** 保存済みフォルダ名 */
    folderName: {
      type    : String,
      required: false,
      default : ''
    },
    /** 保存済みフォルダMIMEタイプ */
    mimeType  : {
      type    : String,
      required: false,
      default : ''
    },
    /** 保存済みフォルダパス */
    folderPath: {
      type    : Array,
      required: false,
    },
    /** パーツ確定 */
    isConfirm: {
      type    : Boolean,
      required: false,
    },
  },
  mounted () {
    // フォルダ一覧取得
    if (this.folderId) {
      // 保存済みのフォルダIDを設定する
      this.selectedFolder.id = this.folderId
      // 保存済みフォルダ配下のフォルダ一覧を取得する
      this.searchFolder(this.folderId)
    } else {
      // ルートのフォルダ一覧を取得する
      this.selectedFolder.id = 'root'
      this.searchFolder('root')
    }
    // 保存済みのフォルダ名を設定する
    if (this.folderName) {
      this.selectedFolder.name = this.folderName
    } else {
      this.selectedFolder.name = 'マイドライブ'
    }
    // 保存済みのフォルダのMIMEタイプを設定する
    if (this.mimeType) {
      this.selectedFolder.mimeType = this.mimeType
    } else {
      if (this.selectedFolder.name === 'マイドライブ') {
        this.selectedFolder.mimeType = this.GOOGLE_DRIVE_FOLDER
      } else {
        this.selectedFolder.mimeType = ''
      }
    }
    // 保存済みの親フォルダIDを設定する
    if (this.folderPath) {
      this.pathHistory = this.folderPath
    } else {
      this.selectedFolder.parents = []
      this.pathHistory = []
    }
    // 初回表示フォルダ情報を親コンポーネントに返す
    this.setFolder(this.selectedFolder)
  },
  computed: {
    /** 選択フォルダ名メッセージ形成 */
    getDirName () {
      let dir_name = ''
      if (this.selectedFolder.name) {
        // フォルダ選択済み
        dir_name = '「' + this.selectedFolder.name + '」へ保存します'
      } else {
        // フォルダ未選択
        dir_name = 'GoogleDriveの保存先を選択してください'
      }
      return dir_name
    },
    // 作成日時形成
    getCreatedTime () {
      return function (createdTime) {
        return moment(createdTime).format('YYYY/MM/DD HH:mm')
      }
    }
  },
  methods: {
    isFolder (item) {
      return Boolean(item.mimeType === this.GOOGLE_DRIVE_FOLDER)
    },
    /** フォルダ選択 */
    setFolder (item){
      if (item.mimeType !== this.GOOGLE_DRIVE_FOLDER) {
        // ファイルの場合は無視
        return
      }
      // 保存先フォルダを設定
      this.selectedFolder = item
      this.$emit('set-folder', item.id, item.name, item.mimeType, this.pathHistory)
    },
    /** フォルダDown */
    downFolder (item) {
      if (item.mimeType !== this.GOOGLE_DRIVE_FOLDER) {
        // フォルダ以外場合は無視
        return
      }
      // ファイルパスのスタックに格納
      this.pathHistory.push(item)

      // 指定フォルダ内検索
      this.searchFolder(item.id)
    },
    /** フォルダUp */
    // ToDo
    // マイドライブでもう一度上に戻る操作しないと
    // 選択中のフォルダがマイドライブにならない
    upFolder () {
      // ファイルパスのスタックから取り出し
      let upFolder = this.pathHistory.pop()
      if (!upFolder) {
        // 戻り先が不明になったらマイドライブに戻る
        upFolder = {
          id      : 'root',
          name    : 'マイドライブ',
          mimeType: this.GOOGLE_DRIVE_FOLDER,
          parents : ['root']
        }
        this.$emit('set-folder', upFolder.id, upFolder.name, upFolder.mimeType, upFolder.parents)
      }

      // 指定フォルダ内検索
      this.selectedFolder = upFolder
      this.searchFolder(upFolder.parents)
    },
    /** フォルダ内検索 */
    searchFolder (folder_id) {
      // フォルダ検索開始
      this.isDriveLoading = true

      // フォルダ移動情報
      const folderData = {
        // HRモンスターのユーザーID
        user_id  : this.userId,
        // 遷移先フォルダID
        folder_id: folder_id
      }

      // フォルダ内検索
      this.$store.dispatch('chatbot/getGoogleDriveFiles', folderData)
        .then((d) => {
          this.itemList = d.filter((item) => !this.temporaryHideFolderID.includes(item.id))
          this.isDriveLoading = false
        })
    },
    /** フォルダ新規作成 */
    createFolder (newFolderName) {
      // フォルダ作成情報
      const folderData = {
        // HRモンスターのユーザーID
        user_id           : this.userId,
        // 選択中のフォルダID
        parent_folder_id  : this.selectedFolder.id,
        // 新規作成フォルダ名
        create_folder_name: this.newFolderName
      }
      // フォルダ作成
      this.$store.dispatch('chatbot/createGoogleDriveFolder', folderData)
        .then(() => {
          // フォルダ内再検索
          this.searchFolder(this.selectedFolder.id)
        })
      this.newFolderName = ''
    },
    /** フォルダ削除確認 */
    deleteFolderConfirm (item) {
      this.delTargetFolder = item

      // アラート表示データ
      const alertData = createAlertData(
        // タイトル
        'フォルダ削除',
        // 本文
        '＜＜※　GoogleDriveのフォルダを直接削除します。ご注意ください！！＞＞\n\n' +
        '以下のフォルダをGoogleDriveから削除しますが、よろしいでしょうか？\n' +
        '「' + this.delTargetFolder.name + '」',
        // アラートの種類
        ALERT_DEF.MESSAGE_DANGER,
        // ダイアログの種類
        ALERT_DEF.DIALOG_CONFIRM,
        // 表示元キーワード
        'GoogleDriveFolderList',
        // 表示元分類キーワード
        'folder-delete'
      )

      // アラート表示
      this.alertData         = alertData
      this.isAlertDialogOpen = true
    },
    /** フォルダ削除 */
    deleteFolder () {
      // 削除フォルダデータ
      const folderData = {
        // HRモンスターのユーザーID
        user_id         : this.userId,
        // 削除フォルダID
        delete_folder_id: this.delTargetFolder.id,
      }

      // フォルダ削除
      this.$store.dispatch('chatbot/deleteGoogleDriveFolder', folderData)
        .then((deleted) => {
          if (deleted) {
            // 正常に削除された
            // Driveへの反映ラグを考慮して一時非表示にする
            this.temporaryHideFolderID.push(folderData.delete_folder_id)
          }
          // フォルダ内再検索
          this.searchFolder(this.selectedFolder.id)
        })
      this.delTargetFolder = {}
      this.upFolder()
      this.setFolder(this.selectedFolder)
    },
    /** アラートダイアログの結果処理 */
    alertResult (alertResultData) {
      if (alertResultData) {
        // アラート結果データあり
        if (alertResultData.alertKeyFunction === 'GoogleDriveFolderList') {
          // GoogleDriveFolderList宛
          if (alertResultData.alertKeyWord === 'folder-delete') {
            // フォルダ削除確認
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // フォルダ削除実行
              this.deleteFolder()
            } else {
              // キャンセルなら初期化
              this.delTargetFolder = {}
            }
          }
          this.isAlertDialogOpen = false
        }
      }
    },
    /** classにactiveを追加する */
    isActive (number) {
      if (number == this.activeNumber) return true
    },
    /** フォルダーのみクリックで背景色が変わる */
    updateActiveNumber (idx, item) {
      //フォルダーを選択した場合
      if (this.isFolder(item)) {
        this.activeNumber = idx
      }
    }
  }
}
</script>

<style scoped>
.table-section {
  width: 100%;
  height: 350px;
  overflow: scroll;
  border: 1px #ccc solid;
  white-space: nowrap;
}
.table-section::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.item-list-table {
  font-size: 12px;
  width: 100%;
}
.item-list-table::-webkit-scrollbar {
  width: 5px;
}
th,
td {
  padding: 4px;
}
.active {
  background-color: #bdf;
}
.item-folder {
  cursor: pointer;
}
.item-file {
  cursor: not-allowed;
}
.is-confirm {
  opacity: 0.3;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/common/GoogleDriveFolderList.vue